import { zodOptional } from '@studio/utils/zod';
import { z } from 'zod';
import { ZAsset } from './library-asset';

export const ZVideoLibraryAsset = z.object({
    id: z.string(),
    name: z.string(),
    url: z.string().min(1),
    width: z.number(),
    height: z.number(),
    thumbnail: ZAsset,
    fileSize: z.number(),
    durationInMilliseconds: z.number(),
    created: z.string(),
    modified: zodOptional(z.string())
});

export type VideoLibraryAsset = z.infer<typeof ZVideoLibraryAsset>;

export const ZVideoLibraryAssetDto = ZVideoLibraryAsset.extend({});
export type VideoFileUploadDto = z.infer<typeof ZVideoLibraryAssetDto>;
